// src/config.js
export const API = process.env.REACT_APP_API || 'http://localhost:3001';
